import { Box, BoxProps, Flex, Heading, Text, useBoolean } from "@chakra-ui/react";
import * as React from "react";
import { Category } from "./_data";
import { Link } from "gatsby";

interface Props {
  category: Category;
  rootProps?: BoxProps;
  staticImage: React.ReactNode;
}

export function CategoryCard({ category, rootProps, staticImage }: Props) {
  return (
    <Box
      position="relative"
      key={category.name}
      borderRadius="lg"
      overflow="hidden"
      opacity={1.0}
      _hover={{ opacity: 0.8, border: "0.5px solid white" }}
      {...rootProps}
    >
      <Link to={category.url}>
        <Box>{staticImage}</Box>
        <Box position="absolute" inset="0" bg="linear-gradient(180deg, rgba(0, 0, 0, 0) 47.92%, #000000 100%)" boxSize="full" />
        <Flex
          color="white"
          direction="column-reverse"
          position="absolute"
          inset="0"
          boxSize="full"
          px={{ base: "4", md: "8" }}
          py={{ base: "6", md: "8", lg: "10" }}
        >
          <Heading fontSize="2xl" fontWeight="extrabold">
            {category.name}
          </Heading>
        </Flex>
      </Link>
    </Box>
  );
}

interface Props2 {
  header: string;
  description: string;
  rootProps?: BoxProps;
  staticImage: React.ReactNode;
  callback?: () => void;
}

export function CardHiddenText({ header, description, rootProps, staticImage, callback = () => {} }: Props2) {
  const [opacity, setOpacity] = React.useState(1);
  const [displayDescription, setDisplayDescription] = React.useState("none");
  const [pushed, setPushed] = useBoolean(false);

  const onClick = () => {
    if (!pushed) {
      setOpacity(0.8);
      setDisplayDescription("block");
    } else {
      setOpacity(1);
      setDisplayDescription("none");
    }
    setPushed.toggle();
    callback();
  };

  return (
    <Box
      position="relative"
      borderRadius="xl"
      overflow="hidden"
      border="0.5px solid white"
      mx="2vw"
      mb="2vh"
      opacity={opacity}
      onClick={onClick}
      {...rootProps}
    >
      <Box>{staticImage}</Box>
      <Box position="absolute" inset="0" bg="linear-gradient(180deg, rgba(0, 0, 0, 0) 47.92%, #000000 100%)" boxSize="full" />
      <Flex color="white" direction="column" position="absolute" inset="0" px={{ base: "4", md: "8" }} py={{ base: "6", md: "8", lg: "10" }}>
        <Box left="30vw">
          <Heading fontSize="2rem" fontWeight="extrabold">
            {header}
          </Heading>
        </Box>
        <Text fontFamily="linotte" color="white" display={displayDescription} mt="3vh" fontSize="1.6rem">
          {description}
        </Text>
      </Flex>
    </Box>
  );
}
